import { lazy, Suspense } from "react";
import {
    IActiveAppStoreIssueAttributes,
    IActiveAppStoreIssueResource,
} from "../../state/types/app-store-issues";

const ClientAppStoreIssueModal = lazy(
    () => import("../../../modules/organization/app-store-issue-modal")
);

export interface AppStoreIssueBannerViewProps {
    visible: boolean;
    issues: IActiveAppStoreIssueResource[];
    activeIssue: IActiveAppStoreIssueAttributes | null;
    onOpenIssue: (issueId: number) => void;
    onCloseIssue: () => void;
}

const AppStoreIssueBannerView: React.FC<AppStoreIssueBannerViewProps> = ({
    visible,
    issues,
    activeIssue,
    onOpenIssue,
    onCloseIssue,
}) => {
    if (!visible || issues.length === 0) return null;

    return (
        <div
            className="w-full"
            role="status"
            aria-live="polite"
            data-testid="app-store-issue-banner"
        >
            {issues.map((res) => {
                const attr = res.attributes;
                const holder =
                    attr.account_holder_email || "the account holder";
                const appName = attr.app_name || "your app";
                return (
                    <div
                        key={res.id}
                        className="w-full bg-red-600 text-white px-4 py-3 flex flex-col md:flex-row md:items-center gap-2"
                        role="alert"
                    >
                        <span
                            className="relative inline-flex items-center justify-center mr-1"
                            aria-hidden="true"
                        >
                            <span className="absolute inline-flex h-3 w-3 rounded-full bg-white opacity-75 animate-ping" />
                            <span className="relative inline-flex rounded-full h-3 w-3 bg-white" />
                        </span>
                        <p className="flex-1 text-sm md:text-base">
                            <span className="font-semibold">
                                ACTION REQUIRED
                            </span>{" "}
                            — {holder} must sign in to {attr.platform_label} to
                            resolve a critical account issue. {appName} may be
                            removed if not resolved.
                        </p>
                        <button
                            type="button"
                            onClick={() => onOpenIssue(res.id)}
                            className="btn btn-sm bg-white text-red-700 hover:bg-red-50 border-white capitalize"
                            data-testid={`banner-resolve-${res.id}`}
                        >
                            Resolve Now
                        </button>
                    </div>
                );
            })}
            {activeIssue && (
                <Suspense fallback={null}>
                    <ClientAppStoreIssueModal
                        issue={activeIssue}
                        isOpen={activeIssue !== null}
                        onClose={onCloseIssue}
                    />
                </Suspense>
            )}
        </div>
    );
};

export default AppStoreIssueBannerView;
